export const STAGES = [
  { key: 'lead', label: 'New lead', dot: 'bg-stone-400' },
  { key: 'contacted', label: 'Contacted', dot: 'bg-sky-500' },
  { key: 'proposal', label: 'Proposal sent', dot: 'bg-indigo-500' },
  { key: 'letter_sent', label: 'Engagement sent', dot: 'bg-amber-500' },
  { key: 'signed', label: 'Signed', dot: 'bg-teal-500' },
  { key: 'fica', label: 'FICA docs', dot: 'bg-emerald-600' },
  { key: 'converted', label: 'Converted', dot: 'bg-emerald-800' },
  { key: 'lost', label: 'Lost', dot: 'bg-red-500' },
];
export const STAGE_LABEL = Object.fromEntries(STAGES.map((s) => [s.key, s.label]));
export const SERVICES = ['Bookkeeping', 'Management accounts', 'VAT', 'Payroll', 'Tax', 'CIPC', 'Audit', 'Advisory'];
export const ENTITY_TYPES = ['Pty Ltd', 'Ltd', 'CC', 'NPC', 'Trust', 'Sole Proprietor', 'Partnership'];
export const DOC_KEYS = [
  ['engagement', 'Engagement Letter'], ['service_agreement', 'Service Agreement & Fee Schedule'],
  ['popia', 'POPIA Consent'], ['debit_order', 'Debit Order Mandate'],
];
export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const zar = (n) => `R ${Number(n || 0).toLocaleString('en-ZA', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
export const daysSince = (d) => (d ? Math.max(0, Math.floor((Date.now() - new Date(d).getTime()) / 86400000)) : 0);
export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  return Array.isArray(d) ? d.map((x) => x.msg).join(', ') : d || 'Something went wrong. Try again.';
};
